import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isTrackedRoutePathname, trackButtonClickFromEvent } from './button-click-analytics';

export function useButtonClickAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (!isTrackedRoutePathname(location.pathname)) {
      return;
    }

    const handleClick = (event: MouseEvent) => {
      trackButtonClickFromEvent(location.pathname, event.target);
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, [location.pathname]);
}
